import React from 'react';
import { Link } from 'react-router-dom';
import logoBlanco from '../../assets/logoblanco.png';
import { FaInstagram, FaLinkedin, FaFacebook } from 'react-icons/fa';

export const Footer = () => {
  return (
    <footer className="footer">
      <div className="container footer-content">
        <div className="footer-brand">
          <Link to="/" style={{ display: 'block', marginBottom: '1rem' }}>
            <img src={logoBlanco} alt="R&M Estudio Contable" style={{ height: '80px' }} />
          </Link>
        </div>
        <div className="footer-links">
          <Link to="/">Inicio</Link>
          <Link to="/servicios">Servicios</Link>
          <Link to="/nosotros">Nosotras</Link>
          <Link to="/contacto">Contacto</Link>
        </div>
        <div className="footer-social">
          <a href="https://instagram.com/contadorasrym" target="_blank" rel="noreferrer" aria-label="Instagram"><FaInstagram /></a>
          <a href="https://www.linkedin.com" target="_blank" rel="noreferrer" aria-label="LinkedIn"><FaLinkedin /></a>
          <a href="https://www.facebook.com" target="_blank" rel="noreferrer" aria-label="Facebook"><FaFacebook /></a>
        </div>
      </div>
      <div className="footer-bottom">
        <p>
          &copy; {new Date().getFullYear()} R&M Estudio Contable. Todos los derechos reservados.
        </p>
        <div style={{ marginTop: '0.5rem', fontSize: '0.5rem', opacity: 0.8 }}>
          <span>Desarrollado por </span>
          <a href="https://www.wapp.com.ar/" target="_blank" rel="noopener noreferrer" style={{ fontWeight: 'bold', color: '#C5A059' }}>
            WAPP SOFTWARE FACTORY
          </a>
        </div>
      </div>
    </footer>
  );
};
